import PendoIcon from '../icon/pendo-icon.vue.js';
import labelsMixin from '../../mixins/labels.js';

var script = {
  name: 'PendoToggle',
  components: {
    PendoIcon
  },
  mixins: [labelsMixin],
  props: {
    value: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      topLabelId: `pendo-toggle-${this._uid}__label--top`,
      bottomLabelId: `pendo-toggle-${this._uid}__label--bottom`
    };
  },
  computed: {
    toggleLabelId() {
      if (this.topLabel) {
        return this.topLabelId;
      }
      if (this.bottomLabel) {
        return this.bottomLabelId;
      }
      return null;
    }
  },
  methods: {
    toggle() {
      if (this.disabled) {
        return;
      }
      this.$emit('change', !this.value);
      this.$emit('input', !this.value);
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-toggle.vue2.js.map
